
export function OpenBlobFile (blobData: any, downloadName: string) {
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobData, downloadName);
    } else {        
        var url = window.URL.createObjectURL(blobData);
        var a = document.createElement('a');
        a.href = url;
        a.download = downloadName;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/utilities/BlobFile.ts